import {translations} from './translations';

export const ADMIN_LANG = translations.fi;
export const DEFAULT_LANG = 'fi'
export const AVAILABLE_LANGUAGES = ['fi', 'en'];

export const [VIEW_USER, ADD_USER, CHANGE_USER, DELETE_USER] = [
    'scope.admin.view_user',
    'scope.admin.add_user',
    'scope.admin.change_user',
    'scope.admin.delete_user'
];

export const [STATUS_PUBLISHED, STATUS_DRAFT, STATUS_ARCHIVED, STATUS_NOT_IN_USE] =
    [1, 2, 3, 4];
